import {
  SearchEntityParams,
  SearchEntityResult,
} from "@/01-core/entity/entities/entity";
import { GenericError, respCodeCheck } from "./error";
import {
  GetSimilarEntityResponse,
  SearchRelatedEntitiesResponse,
} from "../api/generated";
import { SearchEntityResultV2 } from "@/01-core/entity/entities/entityV2";

export const searchEntity = async (body: any, resourceKey: string) => {
  const result = await fetch(`/api/v2/passthrough/entities?lang=zh`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data as SearchEntityResult;
};

export const entityTrend = async (
  body: SearchEntityParams,
  resourceKey: string,
) => {
  const result = await fetch(`/api/v2/passthrough/entities/trend?lang=zh`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data as any;
};

export const entityTrendV2 = async (
  body: SearchEntityParams,
  resourceKey: string,
  apiPath: string,
) => {
  const result = await fetch(`/api/v3/${apiPath}`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data as any;
};

type releatedEntityParams = {
  sourceEntityId: string;
  entityRelationName: string;
  // 后端通用接口定义有问题，这里可以不传F
  requestBody: SearchEntityParams | Record<string, unknown>;
  resourceKey: string;
};
export const releatedEntity = async ({
  sourceEntityId,
  entityRelationName,
  requestBody,
  resourceKey,
}: releatedEntityParams) => {
  const result = await fetch(
    `/api/v2/passthrough/related_entities?lang=zh&source_entity_id=${sourceEntityId}&entity_relation_name=${entityRelationName}`,
    {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "content-type": "application/json",
        "x-biyi-resource-key": resourceKey,
      },
    },
  );
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data as SearchRelatedEntitiesResponse;
};
export const similarEntity = async ({
  entityID,
  entityTypeName,
  resourceKey,
}: {
  resourceKey: string;
  entityID: string;
  entityTypeName: string;
}) => {
  const result = await fetch(
    `/api/v2/passthrough/similar_entity?lang=zh&entity_id=${entityID}&entity_type_name=${entityTypeName}`,
    {
      method: "GET",
      headers: {
        "content-type": "application/json",
        "x-biyi-resource-key": resourceKey,
      },
    },
  );
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data as GetSimilarEntityResponse;
};

export const trendCalendar = async (
  body: SearchEntityParams,
  resourceKey: string,
) => {
  const result = await fetch(
    `/api/v2/passthrough/entities/trend/calendar?lang=zh`,
    {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "content-type": "application/json",
        "x-biyi-resource-key": resourceKey,
      },
    },
  );
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data as any;
};
export const searchEntityV3 = async (
  body: any,
  resourceKey: string,
  apiPath: string,
) => {
  const path = apiPath.startsWith("/") ? apiPath.slice(1) : apiPath;
  const result = await fetch(`/api/v3/${path}`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "content-type": "application/json",
      "x-biyi-resource-key": resourceKey,
    },
  });
  const data = await result.json();
  respCodeCheck(data?.base_resp);
  return data as SearchEntityResultV2;
};
